import { Avatar } from '@mui/material'
import { presetAvatarUrl } from '../config/avatars'
import { resolveAssetUrl } from '../services/assetUrl'
import type { Avatar as AvatarData } from '../services/networkingService'

/**
 * Renders an attendee/person avatar consistently across the app: an uploaded
 * photo, a bundled preset, or an initials-on-color fallback. Falls back to
 * initials when nothing is set.
 */
export default function ProfileAvatar({
  avatar,
  name,
  size = 48,
}: {
  avatar?: AvatarData | null
  name?: string | null
  size?: number
}) {
  const kind = avatar?.avatarKind
  const fallbackInitials =
    avatar?.initials ||
    (name || '')
      .split(' ')
      .map((p) => p[0])
      .filter(Boolean)
      .slice(0, 2)
      .join('')
      .toUpperCase() ||
    '?'

  const sx = { width: size, height: size, fontWeight: 700, fontSize: size * 0.4 }

  if (kind === 'photo' && avatar?.photoUrl) {
    return <Avatar src={resolveAssetUrl(avatar.photoUrl)} alt={name ?? ''} sx={sx} />
  }
  if (kind === 'preset' && avatar?.avatarPreset) {
    return <Avatar src={presetAvatarUrl(avatar.avatarPreset)} alt={name ?? ''} sx={sx} />
  }
  return (
    <Avatar sx={{ ...sx, bgcolor: avatar?.avatarColor || 'primary.main', color: '#fff' }}>
      {fallbackInitials}
    </Avatar>
  )
}
